import { Suspense, useEffect } from "react";
import { Slot, usePathname } from "expo-router";
import Hotjar from "@hotjar/browser";
import { PortalProvider } from "@tamagui/portal";
import mixpanel from "mixpanel-browser";

import { OnlyAuthorized } from "~/component/only-authorized";

import "~/i18n";

import { LoadingScreen } from "~/component/blocks";
import { PerPersonDataSharingAgreement } from "~/component/feature/per-person-data-sharing-agreement";
import env from "~/config";
import { PaymentProvider } from "~/contexts/PaymentContext";
import { useMe } from "~/hooks";

export default function Layout() {
  return (
    <Suspense fallback={<LoadingScreen height={"100dvh"} width={"100vw"} />}>
      <OnlyAuthorized>
        <App />
      </OnlyAuthorized>
    </Suspense>
  );
}

const App = () => {
  const person = useMe();

  const pathname = usePathname();

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    if (Hotjar.isReady()) {
      Hotjar.identify(person.id, {
        name: person.name,
        email: person.email,
      });
    }
    if (person) {
      if (env.MIXPANEL_TOKEN) {
        try {
          mixpanel.identify(person.id);
        } catch (e) {
          console.error("mixpanel set identify error", e);
        }
      }
    }
  }, [person]);

  return (
    <PortalProvider shouldAddRootHost>
      <PaymentProvider>
        {person.perPersonDataSharingAgreement ? (
          <PerPersonDataSharingAgreement
            content={person.perPersonDataSharingAgreement}
          />
        ) : (
          <Slot />
        )}
      </PaymentProvider>
    </PortalProvider>
  );
};
